import { useStyles } from '@wix/tpa-settings/react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import isEqual from 'lodash/isEqual';
import { type CSSProperties } from 'react';

import { EXPERIMENTS } from '../../../constants/experiments';
import stylesParams from '../stylesParams';

const HEADING_OVERRIDES = [
  {
    font: stylesParams.headerOneFont,
    cssVar: '--wix-forms-formHeaderOneFont',
    newCssVar: '--wix-forms-formHeaderOneFontH1',
  },
  {
    font: stylesParams.headerTwoFont,
    cssVar: '--wix-forms-formHeaderTwoFont',
    newCssVar: '--wix-forms-formHeaderTwoFontH2',
  },
] as const;

export const useHeadingOverrides = (): CSSProperties => {
  const styles = useStyles();
  const { experiments } = useExperiments();

  if (!experiments.enabled(EXPERIMENTS.ENABLE_HEADING_LEVELS)) {
    return {};
  }

  const overrides: Record<string, string> = {};

  for (const { font, cssVar, newCssVar } of HEADING_OVERRIDES) {
    // Heading 1 is connected to Heading 5 site theme value, and Heading 2 to Heading 6.
    // When isHeadingLevelsEnabled is on, headings should match corresponding theme values
    // (e.g., Heading 1 use Heading 1 theme value) unless they have been customized
    // (disconnected from the theme)
    const fontCurrent = styles.get(font);
    const fontDefault = styles.getDefaultValue(font);
    const isConnectedToTheme = isEqual(fontCurrent, fontDefault);

    // When using CSS vars, site-theme updates are reflected on widget without a reload
    if (isConnectedToTheme) {
      overrides[`${cssVar}-size`] = `var(${newCssVar}-size)`;
      overrides[`${cssVar}-family`] = `var(${newCssVar}-family)`;
    }
  }

  return overrides as unknown as CSSProperties;
};
